module.exports = __webpack_public_path__ + "1778ca8409a7c7f8e346fd0c1239425f.png";